import React from "react";
import Box from "@carrier-io/air-react/Box";
import {
  Navbar,
  NavbarFooter,
  NavbarFooterButton,
  Navigation,
  NavigationButton,
} from "@carrier-io/air-react/patterns/Navbar";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import { SvgIcon } from "@carrier-io/air-react";
import { colors } from "../../styles/colors";

export const AdminBar = () => {
  return (
    <Box
      component="nav"
      sx={{
        gridArea: "nav",
        backgroundColor: "white",
        borderRight: `1px solid ${colors.borderColorLight}`,
        overflow: "hidden",
      }}
    >
      <Navbar heightOffset={0}>
        <Navigation
          currentPathname="/admin"
          items={[
            {
              icon: (
                <SvgIcon fontSize="large">
                  <path
                    d="M19.51 3.08L3.08 19.51C3.17 19.85 3.35 20.16 3.59 20.41C3.84 20.65 4.15 20.83 4.49 20.92L20.93 4.49C20.74 3.8 20.2 3.26 19.51 3.08ZM11.88 3L3 11.88V14.71L14.71 3H11.88ZM5 3C3.9 3 3 3.9 3 5V7L7 3H5ZM19 21C19.55 21 20.05 20.78 20.41 20.41C20.78 20.05 21 19.55 21 19V17L17 21H19ZM9.29 21H12.12L21 12.12V9.29L9.29 21Z"
                    fill="#63676B"
                  />
                </SvgIcon>
              ),
              id: "test",
              path: "/",
            },
            {
              icon: (
                <SvgIcon fontSize="large">
                  <path
                    d="M19.51 3.08L3.08 19.51C3.17 19.85 3.35 20.16 3.59 20.41C3.84 20.65 4.15 20.83 4.49 20.92L20.93 4.49C20.74 3.8 20.2 3.26 19.51 3.08ZM11.88 3L3 11.88V14.71L14.71 3H11.88ZM5 3C3.9 3 3 3.9 3 5V7L7 3H5ZM19 21C19.55 21 20.05 20.78 20.41 20.41C20.78 20.05 21 19.55 21 19V17L17 21H19ZM9.29 21H12.12L21 12.12V9.29L9.29 21Z"
                    fill="#63676B"
                  />
                </SvgIcon>
              ),
              id: "test1",
              path: "/",
            },
            {
              icon: (
                <SvgIcon fontSize="large">
                  <path
                    d="M19.51 3.08L3.08 19.51C3.17 19.85 3.35 20.16 3.59 20.41C3.84 20.65 4.15 20.83 4.49 20.92L20.93 4.49C20.74 3.8 20.2 3.26 19.51 3.08ZM11.88 3L3 11.88V14.71L14.71 3H11.88ZM5 3C3.9 3 3 3.9 3 5V7L7 3H5ZM19 21C19.55 21 20.05 20.78 20.41 20.41C20.78 20.05 21 19.55 21 19V17L17 21H19ZM9.29 21H12.12L21 12.12V9.29L9.29 21Z"
                    fill="#63676B"
                  />
                </SvgIcon>
              ),
              id: "test2",
              path: "/",
            },
            {
              icon: (
                <SvgIcon fontSize="large">
                  <path
                    d="M19.51 3.08L3.08 19.51C3.17 19.85 3.35 20.16 3.59 20.41C3.84 20.65 4.15 20.83 4.49 20.92L20.93 4.49C20.74 3.8 20.2 3.26 19.51 3.08ZM11.88 3L3 11.88V14.71L14.71 3H11.88ZM5 3C3.9 3 3 3.9 3 5V7L7 3H5ZM19 21C19.55 21 20.05 20.78 20.41 20.41C20.78 20.05 21 19.55 21 19V17L17 21H19ZM9.29 21H12.12L21 12.12V9.29L9.29 21Z"
                    fill="#63676B"
                  />
                </SvgIcon>
              ),
              id: "test3",
              path: "/",
            },
          ]}
          sx={{
            gap: "24px",
          }}
        />
        <NavbarFooter showCarrierLogo>
          <NavigationButton
            data={{
              id: "settings",
            }}
            disableTooltip
            onClick={() => {
              /* TODO: Add handler */
            }}
            sx={{ height: "auto !important" }}
          >
            <SettingsOutlinedIcon
              sx={{
                backgroundColor: `${colors.outlinedBackground}`,
                borderRadius: "4px",
              }}
            />
          </NavigationButton>
          <NavbarFooterButton
            size="large"
            sx={{
              width: "40px !important",
              height: "40px !important",
              borderRadius: "50%",
              justifyContent: "center !important",
              backgroundColor: `${colors.navbarFooterBtn}`,
            }}
          >
            <HelpOutlineOutlinedIcon
              sx={{
                color: `${colors.helpOutlineBtn} !important`,
                width: "24px",
                height: "24px",
              }}
            />
          </NavbarFooterButton>
        </NavbarFooter>
      </Navbar>
    </Box>
  );
};
